export default [
  { value: 'INITIAL_SEARCH', label: 'Initial search' },
  { value: 'SECOND_SEARCH', label: 'Second search' },
  { value: 'THIRD', label: 'Third search' },
];
